import { formatTier, formatProductArea, formatProductPrice } from '../../../shared/utils/index.js'
import { PRODUCT_ATTRIBUTE_IDS } from '../../../shared/constants/productAttributes.js'

import { VIEW_MODE } from '../utils/viewModes.js'
import { DATA_ITEMS_IDS } from '../constants/catalogDataDisplay.js'

/**
 * Single source of truth for all displayable data points across Table, Cards, and Tiles.
 */
export const CATALOG_DISPLAY_REGISTRY = [
    {
        id: DATA_ITEMS_IDS.ID_CAD,
        labelKey: 'common.number',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS], // in tile viewMode rendered in open CTA button
        isSupported: () => true,
        getValue: (p) => p.id_original ?? p.crm_id_unit ?? p.number ?? p.id_cad ?? null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.INVESTMENT,
        labelKey: 'common.investment',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: () => true,
        getValue: (p) => p.investment_name ?? null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.BUILDING,
        labelKey: 'common.building',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: (context) => context?.hasMultipleBuildings !== false,
        getValue: (p) => p.building_name ?? p.building_id ?? null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.GATE,
        labelKey: 'common.gate',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: (context) => context?.hasMultipleGates !== false,
        getValue: (p) => p.gate ?? null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.TIERS,
        labelKey: 'common.floor',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: () => true,
        getValue: (p, { tiers } = {}) => formatTier(p, tiers),
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.ROOMS,
        labelKey: 'common.rooms',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: () => true,
        getValue: (p) => p.rooms ?? null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.AREA,
        labelKey: 'common.area_m2',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: () => true,
        getValue: (p) => formatProductArea(p),
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.STATUS,
        labelKey: 'common.status',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: () => true,
        getValue: (p) => p.status ?? null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.PRICE,
        labelKey: 'common.price',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: (context) => context?.pricesVisible !== false,
        getValue: (p, context) => formatProductPrice(p, context?.pricesVisibility)?.displayPrice ?? null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.ACTIONS,
        labelKey: '',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        isSupported: (context) => (context?.hasActiveCatalogActions === true),
        getValue: () => null,
    },
    {
        id: PRODUCT_ATTRIBUTE_IDS.INQUIRY,
        labelKey: '',
        supportedViews: [VIEW_MODE.LIST, VIEW_MODE.CARDS, VIEW_MODE.TILES],
        // isSupported: (context) => context?.inquiryConfig?.enabled === true,
        getValue: () => null,
    },
]

export function getDisplayItem(id) {
  return CATALOG_DISPLAY_REGISTRY.find((item) => item.id === id)
}